import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Modal, ModalInner } from 'components';
import { SpaceCraftGridData } from './types';
import axios from 'common/AxiosAuth';

interface ModalProps {
  data: SpaceCraftGridData[] | null;
  setData: Dispatch<SetStateAction<SpaceCraftGridData[] | null>>;
  onDeleted: () => void;
  setCheckedRows: (rows: number[]) => void;
}

const DeleteModal = ({ data, setData, onDeleted, setCheckedRows }: ModalProps) => {
  const { t } = useTranslation();
  async function onDelete() {
    if (data && data.length > 0) {
      const ids = data.map(item => item.id);

      try {
        await axios.delete('/api/link/removeLinks', {
          data: ids
        });
        onDeleted();
        setData(null);
        setCheckedRows([]); // 체크박스 초기화
      } catch (error) {
        console.error("Error deleting items:", error);
      }
    }
  }

  function onCancel() {
    setData(null);
  }

  return (
    <Modal isOpened={!!data}>
      <ModalInner className="md:w-[400px]" title={t('manage.modal.deleteTitle')} onClickClose={onCancel}>
        <p className="p-4 pt-0 text-body1">{t('manage.modal.deleteMessage')}</p>
        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text={t('manage.button.cancel')} onClick={onCancel} type="secondary" size="large" />
          <Button className="h-9 bg-red-600 border-red-600" text={t('manage.button.delete')} onClick={onDelete} type="blue" size="large" />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default DeleteModal;
